import { app } from '../../bootstrap/core';
import { ownerState } from './owner.state';
import { ownerComponent } from './owner.component';
import { OwnerModel } from './owner.model';

app.config(ownerState);
app.component(ownerComponent.name, ownerComponent);
app.factory('OwnerModel', () => OwnerModel);




// WEBPACK FOOTER //
// ./src/app/components/owner/owner.js